<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard v-if="form">
        <CCardBody>
          <h3>
            Edit Program
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CForm v-if="form">
            <div class="all mb-2">
              <!-- <CSwitch
                color="success" 
                labelOn="Active"
                labelOff="Inactive"
                shape="pill" 
                size="lg" 
                class="float-left" 
                :checked="form.active"
                style="width:100px;"
              /> -->
              <label>Active/Inactive</label>
              <div>
                <CButton size="sm" @click="form.active = 1" :color="form.active === 1 ? 'success': 'outline-success'">Active</CButton>
                <CButton size="sm" @click="form.active = 0" style="margin-left:5px;" :color="form.active === 0 ? 'danger': 'outline-danger'">Inactive</CButton>
              </div>
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Program Name"
                :value.sync="form.program_name"
                placeholder="Program Name"
                autocomplete="given-name"
                disabled
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Netsuite Program Internal ID"
                :value.sync="form.internal_id"
                placeholder="NetSuite program internal ID"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Netsuite Custom Form Internal ID"
                :value.sync="form.custom_form_internal_id"
                placeholder="NetSuite custom form internal ID"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Days Out for Shipping"
                type="number"
                :value.sync="form.days_out"
                placeholder="Days Out to Order"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Can't Order Until Date (leave blank if not needed)"
                type="date"
                :value.sync="form.order_until_date"
                placeholder="Can't order until..."
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <label>Allow Blanks</label>{{form.allow_blanks}}
              <select class="form-control" v-model="form.allow_blanks">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="float-left col-sm-12 p-0 mt-3" v-if="form.allow_blanks">
              <CInput
                :lazy="false"
                label="Blank Deduction Price"
                type="text"
                :value.sync="form.blank_deduction_price"
                placeholder="Do not put $ in front of price..."
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0 mt-3" v-if="form.allow_blanks === 1">
              <CInput
                :lazy="false"
                label="USA lead time"
                type="text"
                :value.sync="form.blank_deduction_price"
                placeholder="Do not put $ in front of price..."
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="mt-3 float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Subtract Quantity (x amount from min quantity)"
                type="number"
                :value.sync="form.subtract_quantity"
                placeholder="Ex 6 units under min quantity"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Upcharge Min Pieces < Min Quantity"
                type="text"
                :value.sync="form.subtract_upcharge"
                placeholder="Ex $1.75 upcharge per under min quantity"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Free Decorations"
                type="number"
                :value.sync="form.free_decorations"
                placeholder="Ex 1"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>

            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Prebook Ship Days Out"
                type="number"
                :value.sync="form.prebook_days"
                placeholder="Ex 1"
                autocomplete="given-name"
              />
            </div>

            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Min Locations"
                type="number"
                :value.sync="form.min_locations"
                placeholder="Ex 1"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Max Locations (leave blank for unlimited)"
                type="number"
                :value.sync="form.max_locations"
                placeholder="Ex 1"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 pt-3 p-0">
              <CInput
                :lazy="false"
                label="Discount Rate Internal ID (if there is one)"
                type="text"
                :value.sync="form.discount_rate_internal_id"
                placeholder="Ex 12345"
                autocomplete="given-name"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <label>Deduction Type</label>
              <v-select v-model="form.meet_min_quantity_deduction_type" :options="['flat_rate', 'percentage']"></v-select>
            </div>
            <div class="float-left col-sm-12 pt-3 p-0">
              <CInput
                :lazy="false"
                label="Deduction"
                type="text"
                :value.sync="form.meet_min_quantity_deduction"
                placeholder="Ex 1.50"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <CInput
                :lazy="false"
                label="Program Emails (split with a comma)"
                type="text"
                :value.sync="form.program_emails"
                placeholder="Ex acoleman@paifashion.com,hmcmeen@paifashion.com"
              />
            </div>
            <div class="float-left col-sm-12 p-0">
              <label>Color Type Options</label>
              <v-select v-model="form.color_type_options" multiple :options="colorTypeOptions"></v-select>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Available to User Type(s) (leave blank for all user types)</label>
              <v-select v-if="roles" v-model="form.menuroles" multiple :options="roles"></v-select>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>One style per order?</label>
              <div>
                <CButton size="sm" @click="form.one_style_per = 1" :color="form.one_style_per === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.one_style_per = 0" style="margin-left:5px;" :color="form.one_style_per === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
            <div class="mt-3 float-left col-sm-12 p-0" v-if="form.one_style_per">
              <CInput
                :lazy="false"
                label="Min Quantity"
                type="number"
                :value.sync="form.min_quantity"
                placeholder="Min Quantity"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>
            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Split Order Groups By Product Class?</label>
              <div>
                <CButton size="sm" @click="form.split_by_product_class = 1" :color="form.split_by_product_class === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.split_by_product_class = 0" style="margin-left:5px;" :color="form.split_by_product_class === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Enable 1-23 Upcharge?</label>
              <div>
                <CButton size="sm" @click="form.allow_one_to_23_upcharge = 1" :color="form.allow_one_to_23_upcharge === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.allow_one_to_23_upcharge = 0" style="margin-left:5px;" :color="form.allow_one_to_23_upcharge === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Layout Text Option?</label>
              <div>
                <CButton size="sm" @click="form.layout_text_option = 1" :color="form.layout_text_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.layout_text_option = 0" style="margin-left:5px;" :color="form.layout_text_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Rush Option?</label>
              <div>
                <CButton size="sm" @click="form.rush_option = 1" :color="form.rush_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.rush_option = 0" style="margin-left:5px;" :color="form.rush_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Allow Fast Lane?</label>
              <div>
                <CButton size="sm" @click="form.allow_fastlane = 1" :color="form.allow_fastlane === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.allow_fastlane = 0" style="margin-left:5px;" :color="form.allow_fastlane === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>In Hands Date Option?</label>
              <div>
                <CButton size="sm" @click="form.in_hands_date_option = 1" :color="form.in_hands_date_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.in_hands_date_option = 0" style="margin-left:5px;" :color="form.in_hands_date_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Has to be quantities of 6?</label>
              <div>
                <CButton size="sm" @click="form.sixes = 1" :color="form.sixes === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.sixes = 0" style="margin-left:5px;" :color="form.sixes === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Show Internal Notes?</label>
              <div>
                <CButton size="sm" @click="form.show_internal_notes = 1" :color="form.show_internal_notes === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.show_internal_notes = 0" style="margin-left:5px;" :color="form.show_internal_notes === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Ribbon Option?</label>
              <div>
                <CButton size="sm" @click="form.ribbon_option = 1" :color="form.ribbon_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.ribbon_option = 0" style="margin-left:5px;" :color="form.ribbon_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Hangtags Option?</label>
              <div>
                <CButton size="sm" @click="form.hangtags_option = 1" :color="form.hangtags_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.hangtags_option = 0" style="margin-left:5px;" :color="form.hangtags_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
            <div class="float-left col-sm-12 mt-3 p-0">
              <label>String Tag Option?</label>
              <div>
                <CButton size="sm" @click="form.string_tags_option = 1" :color="form.string_tags_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.string_tags_option = 0" style="margin-left:5px;" :color="form.string_tags_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Imperial Customers Only?</label>
              <div>
                <CButton size="sm" @click="form.imperial_belts_settings = 1" :color="form.imperial_belts_settings === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.imperial_belts_settings = 0" style="margin-left:5px;" :color="form.imperial_belts_settings === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>PM Customers Only?</label>
              <div>
                <CButton size="sm" @click="form.pm_belts_settings = 1" :color="form.pm_belts_settings === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.pm_belts_settings = 0" style="margin-left:5px;" :color="form.pm_belts_settings === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Insert Order Sizes On Same Line In NetSuite?</label>
              <div>
                <CButton size="sm" @click="form.insert_net_suite_combined_sizes = 1" :color="form.insert_net_suite_combined_sizes === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.insert_net_suite_combined_sizes = 0" style="margin-left:5px;" :color="form.insert_net_suite_combined_sizes === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Other Colors Option? (Click to add color)</label>
              <div>
                <CButton size="sm" @click="form.other_color_option = 1" :color="form.other_color_option === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.other_color_option = 0" style="margin-left:5px;" :color="form.other_color_option === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Show Production Notes?</label>
              <div>
                <CButton size="sm" @click="form.show_production_notes = 1" :color="form.show_production_notes === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.show_production_notes = 0" style="margin-left:5px;" :color="form.show_production_notes === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Additional Locations Charge?</label>
              <div>
                <CButton size="sm" @click="form.additional_locations_charge = 1" :color="form.additional_locations_charge === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.additional_locations_charge = 0" style="margin-left:5px;" :color="form.additional_locations_charge === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div>
            <!-- <div class="float-left col-sm-12 mt-3 p-0">
              <label>Belt Program? (This will make it so that you can only select one location)</label>
              <div>
                <CButton size="sm" @click="form.belt_program = 1" :color="form.belt_program === 1 ? 'success': 'outline-success'">Yes</CButton>
                <CButton size="sm" @click="form.belt_program = 0" style="margin-left:5px;" :color="form.belt_program === 0 ? 'danger': 'outline-danger'">No</CButton>
              </div>
            </div> -->
            <div class="mt-3 float-left col-sm-12 p-0" v-if="form.additional_locations_charge">
              <CInput
                :lazy="false"
                label="Additional Locations Charge Cost"
                type="text"
                :value.sync="form.additional_locations_charge_cost"
                placeholder="Cost (Do not put $)"
                autocomplete="given-name"
                invalidFeedback="This is a required field"
              />
            </div>

            <spacer />

            <div class="float-left col-sm-12 mt-3 p-0">
              <label>Copy Another Program's Techniques & Locations?</label>
              <v-select v-if="programOptions" v-model="copy_program" label="program_name" :options="programOptions"></v-select>
              <CButton size="sm" color="info" style="margin-top:10px;" @click="copyProgram()" v-if="copy_program && !copyLoading">Submit Copy</CButton>
              <small-loader v-if="copyLoading"></small-loader>
            </div>

            <div v-if="programOptions" class="float-left mt-3 col-sm-12 p-0">
              <label>Copy Styles to the selected programs</label>
              <v-select v-if="programOptions" v-model="form.copy_styles_to_programs" multiple label="program_name" :options="programOptions"></v-select>
              <!-- <CButton size="sm" color="info" style="margin-top:10px;" @click="copyProgram()">Submit Copy</CButton> -->
              <!-- <small-loader v-if="copyLoading"></small-loader> -->
            </div>

            <div style="width:100%;float:left;margin-top:15px;">
              <CCard>
                <CCardHeader color="secondary" @click="decorationCollapsed = !decorationCollapsed">Specific Decorations
                  <div class="card-header-actions">
                    <CLink class="card-header-action btn-minimize">
                      <CIcon :name="`cil-chevron-${decorationCollapsed ? 'bottom' : 'top'}`"/>
                    </CLink>
                  </div>
                </CCardHeader>
                <CCollapse :show="decorationCollapsed" :duration="400">
                  <CCardBody>
                    <h5 class="text-center" style="font-size:.8em;">Notice: if there are images uploaded for this program, these will be the only images that a csr/rep can select from when choosing this program.</h5>
                    <div style="width:100%;float:left;background-color:#000;" v-if="form.image_options && !removeLoading">
                      <CCarousel
                        arrows
                        indicators
                        animate
                        height="300px"
                        ref="programDecorations"
                        @setItem="decorationChanged(...arguments)"
                      >
                        <!-- <CCarouselItem
                          captionHeader="First Slide"
                          image="https://picsum.photos/1024/480/?image=52"
                          captionText="Nulla vitae elit libero, a pharetra augue mollis interdum."
                        />
                        <CCarouselItem
                          captionHeader="Blank page"
                          :image="{ placeholderColor: 'grey' }"
                          captionText="Nulla vitae elit libero, a pharetra augue mollis interdum."
                        /> -->
                        <CCarouselItem
                          v-for="(image, index) in form.image_options"
                          style="height:300px;"
                          :key="index"
                        >
                          <div style="width:100%;text-align:center;margin-bottom:10px;margin-top:10px;">
                            <CButton size="sm" color="danger" @click="remove(image, index)">Remove Image</CButton>
                          </div>
                          <image-wrapper v-if="activeProgDec === index" :auto_load="true" :img="image" :imageIndex="index" imgStyle="max-width:100%;max-height:200px;" :src="image.file_url" />
                        </CCarouselItem>
                      </CCarousel>
                    </div>
                    <div style="width:100%;float:left;">
                      <vue-dropzone ref="programDropzone" @vdropzone-file-added="addFile" name="files" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                      <div style="width:100%;float:left;text-align: center;">
                        <CButton size="sm" color="success" v-if="imageUploads.length && !fileLoading" class="mt-2 ml-auto mr-auto" @click="uploadFiles()">Submit Image(s)</CButton>
                        <small-loader v-else-if="fileLoading"></small-loader>
                      </div>
                    </div>
                  </CCardBody>
                </CCollapse>
              </CCard>
            </div>
          </CForm>
          <spacer />
          <!-- <div style="width:100%;float:left;">
            <h5 style="width:100%;float:left;text-align: center;">Pricing Tiers</h5>
            <div style="width:100%;float:left;" v-for="(v, i) in form.tier_names">
              <input type="text" class="form-control" style="width:350px;margin-left:auto;margin-right:auto;margin-bottom:10px;" v-model="v.tier_name" placeholder="Tier Name..." />
              <div style="width:100%;float:left;text-align:center;">
                <h5 style="font-size:13px;">Styles in Tier</h5>
                <multiselect 
                    v-model="v.styles" 
                    :options="form.styles" 
                    :multiple="true" 
                    :closeOnSelect="false"
                  />
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th>Min Total Quantity</th>
                    <th>Per Color Quantity</th>
                    <th>Min Num Styles</th>
                    <th>Price Per Style</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="v.tiers">
                  <tr v-for="(val, index) in v.tiers">
                    <td>
                      <input type="number" style="width:70px;" v-model="val.min_quantity" class="form-control float-left" />
                    </td>
                    <td>
                      <input type="number" style="width:70px;" v-model="val.min_color_quantity" class="form-control float-left" />
                    </td>
                    <td>
                      <input type="number" style="width:70px;" v-model="val.num_styles" class="form-control float-left" />
                    </td>
                    <td>
                      <input type="text" style="width:150px;" v-model="val.price" class="form-control float-left" />
                    </td>
                    <td>
                      <CButton size="sm" color="danger" @click="removeTier(val, index, i)">Remove</CButton>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td colspan="6" style="text-align: center;">
                      <CButton size="sm" color="success" @click="addTier(i)">Add Tier</CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <CButton size="sm" color="success" @click="addTierGroup()">Add New Tier Group</CButton>
            <CButton size="sm" color="info" class="ml-2" @click="update()">Save Tiers</CButton>
          </div>
          <spacer /> -->
          <div style="width:100%;float:left;">
            <CCard>
              <CCardHeader @click="royaltiesCollapsed = !royaltiesCollapsed">Program Royalties
                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize">
                    <CIcon :name="`cil-chevron-${royaltiesCollapsed ? 'bottom' : 'top'}`"/>
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="royaltiesCollapsed" :duration="400">
                <CCardBody>
                  <div style="width:100%;float:left;overflow-x: scroll;">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Code</th>
                          <th>Price</th>
                          <th>Per Piece</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody v-if="form.royalties && form.royalties.length">
                        <tr v-for="(v, index) in form.royalties">
                          <td>
                            <input type="text" style="width:150px;" v-model="v.charge_name" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:150px;" v-model="v.charge_code" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:70px;" v-model="v.price" class="form-control float-left" />
                          </td>
                          <td>
                            <CButton size="sm" @click="v.per_piece = 1" :color="v.per_piece === 1 ? 'success': 'outline-success'">Yes</CButton>
                            <CButton size="sm" @click="v.per_piece = 0" style="margin-left:5px;" :color="v.per_piece === 0 ? 'danger': 'outline-danger'">No</CButton>
                          </td>
                          <td>
                            <CButton size="sm" color="danger" @click="form.royalties.splice(index, 1), form.royalty_edited = true">Remove</CButton>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <td>
                            <input type="text" style="width:150px;" v-model="royalty.charge_name" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:150px;" v-model="royalty.charge_code" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:70px;" v-model="royalty.price" class="form-control float-left" />
                          </td>
                          <td>
                            <CButton size="sm" @click="royalty.per_piece = 1" :color="royalty.per_piece === 1 ? 'success': 'outline-success'">Yes</CButton>
                            <CButton size="sm" @click="royalty.per_piece = 0" style="margin-left:5px;" :color="royalty.per_piece === 0 ? 'danger': 'outline-danger'">No</CButton>
                          </td>
                          <td>
                            <CButton size="sm" color="success" @click="addRoyalty()">Add</CButton>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CCardBody>
              </CCollapse>
            </CCard>
          </div>

          <div style="width:100%;float:left;">
            <CCard>
              <CCardHeader @click="techniqueCollapsed = !techniqueCollapsed">Technique Settings
                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize">
                    <CIcon :name="`cil-chevron-${techniqueCollapsed ? 'bottom' : 'top'}`"/>
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="techniqueCollapsed" :duration="400">
                <CCardBody>
                  <div style="width:100%;float:left;overflow-x: scroll;" v-if="form.techniques">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Min Quant</th>
                          <th>New Min Quant</th>
                          <th>Free Decorations</th>
                          <th>Cost</th>
                          <th>Distr Cost</th>
                          <th>Lead Time</th>
                          <th style="min-width:125px;">Can Go Under New Min?</th>
                          <th style="min-width:125px;">Fast Lane?</th>
                          <th style="min-width:125px;">Free Sewdown?</th>
                          <th style="min-width:125px;">Disabled?</th>
                          <th>Under Upcharge</th>
                          <th>1-23 Cost</th>
                          <th>Total Order</th>
                          <th>Split Key</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="val in form.techniques">
                          <td>{{val.technique_name}}</td>
                          <td>
                            <input type="number" style="width:70px;" v-model="val.min_quantity" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="number" style="width:70px;" v-model="val.new_min_quantity" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="number" style="width:70px;" v-model="val.free_decorations" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:70px;" v-model="val.cost" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:70px;" v-model="val.distributor_cost" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="number" style="width:70px;" v-model="val.lead_time" class="form-control float-left" />
                          </td>
                          <td>
                            <CButton size="sm" @click="val.can_go_under_new_min_quantity = 1" :color="val.can_go_under_new_min_quantity === 1 ? 'success': 'outline-success'">Yes</CButton>
                            <CButton size="sm" @click="val.can_go_under_new_min_quantity = 0" style="margin-left:5px;" :color="val.can_go_under_new_min_quantity === 0 ? 'danger': 'outline-danger'">No</CButton>
                          </td>
                          <td>
                            <CButton size="sm" @click="val.allow_fastlane = 1" :color="val.allow_fastlane === 1 ? 'success': 'outline-success'">Yes</CButton>
                            <CButton size="sm" @click="val.allow_fastlane = 0" style="margin-left:5px;" :color="val.allow_fastlane === 0 ? 'danger': 'outline-danger'">No</CButton>
                          </td>
                          <td>
                            <CButton size="sm" @click="val.free_sewdown = 1" :color="val.free_sewdown === 1 ? 'success': 'outline-success'">Yes</CButton>
                            <CButton size="sm" @click="val.free_sewdown = 0" style="margin-left:5px;" :color="val.free_sewdown === 0 ? 'danger': 'outline-danger'">No</CButton>
                          </td>
                          <td>
                            <CButton size="sm" @click="val.disabled = 1" :color="val.disabled === 1 ? 'success': 'outline-success'">Yes</CButton>
                            <CButton size="sm" @click="val.disabled = 0" style="margin-left:5px;" :color="val.disabled === 0 ? 'danger': 'outline-danger'">No</CButton>
                          </td>
                          <td>
                            <input type="text" style="width:70px;" v-model="val.under_min_quantity_upcharge" class="form-control float-left" />
                          </td>
                          <td>
                            <input type="text" style="width:70px;" v-model="val.one_to_23_upcharge_cost" class="form-control float-left" />
                          </td>
                          <td>
                            <CButton size="sm" @click="val.add_per_order ? val.add_per_order = 0 : val.add_per_order = 1" :color="val.add_per_order === 1 ? 'info': 'outline-info'">{{val.add_per_order ? 'Yes' : 'No'}}</CButton>
                          </td>
                          <td>
                            <input type="text" style="width:100px;" v-model="val.split_order_key" class="form-control float-left" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CCardBody>
              </CCollapse>
            </CCard>
          </div>

          <div style="width:100%;float:left;">
            <CCard color="default" v-if="form.techniques" :key="index" v-for="(val, index) in form.techniques">
              <CCardHeader @click="val.collapsed = !val.collapsed">
                <label style="float: left;padding-top:6px;">{{val.technique_name}}</label>

                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize">
                    <CIcon :name="`cil-chevron-${val.collapsed ? 'bottom' : 'top'}`"/>
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="val.collapsed" :duration="400">
                <CCardBody>
                  <!-- <center>Locations</center> -->
                  <!-- <v-select :closeOnSelect="false" v-if="locations" :options="locations" label="label" v-model="val.locations" multiple>

                  </v-select> -->
                  <CCard>
                    <CCardHeader @click="val.locationsCollapsed = !val.locationsCollapsed">
                      Select Locations
                      <div class="card-header-actions">
                        <CLink class="card-header-action btn-minimize">
                          <CIcon :name="`cil-chevron-${val.locationsCollapsed ? 'bottom' : 'top'}`"/>
                        </CLink>
                      </div>
                    </CCardHeader>
                    <CCollapse :show="val.locationsCollapsed" :duration="400">
                      <CCardBody>
                        <multiselect
                          v-if="locations" 
                          v-model="val.locations" 
                          :options="locations" 
                          :multiple="true" 
                          :closeOnSelect="false"
                          label="label" 
                          track-by="label"
                        />
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                  <CCard>
                    <CCardHeader @click="val.locationsTableCollapsed = !val.locationsTableCollapsed">
                      Locations Table
                      <div class="card-header-actions">
                        <CLink class="card-header-action btn-minimize">
                          <CIcon :name="`cil-chevron-${val.locationsTableCollapsed ? 'bottom' : 'top'}`"/>
                        </CLink>
                      </div>
                    </CCardHeader>
                    <CCollapse :show="val.locationsTableCollapsed" :duration="400">
                      <CCardBody>
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th style="min-width:125px;">Does this location qualify for a free decoration?</th>
                              <th style="min-width:125px;">Free Decorations</th>
                              <th>Cost</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="loc in val.locations">
                              <td>
                                <div v-if="loc.location_name">{{loc.location_code}} - {{loc.location_name}} - {{loc.product_class}}</div>
                              </td>
                              <td>
                                <CButton size="sm" @click="loc.location_for_free_decoration_matters = 1" :color="loc.location_for_free_decoration_matters === 1 ? 'success': 'outline-success'">Yes</CButton>
                                <CButton size="sm" @click="loc.location_for_free_decoration_matters = 0" style="margin-left:5px;" :color="loc.location_for_free_decoration_matters === 0 ? 'danger': 'outline-danger'">No</CButton>
                              </td>
                              <td>
                                <input v-show="loc.location_for_free_decoration_matters" type="number" style="width:70px;" v-model="loc.free_decorations" class="form-control float-left" />
                              </td>
                              <td>
                                <input v-show="loc.location_for_free_decoration_matters" type="text" style="width:70px;" v-model="loc.technique_cost" class="form-control float-left" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </CCardBody>
              </CCollapse>
            </CCard>
          </div>
            <div style="width:100%;float:left;margin-top:15px;" v-if="!loading">
              <CButton color="primary" @click="update()">Save</CButton>
              <CButton color="bg-gray-100" class="ml-2" @click="goBack">Back</CButton>
            </div>
            <small-loader v-else-if="loading"></small-loader>
            <div style="width:100;float:left;height:50px;margin-top:15px;">
              <CAlert
                :show.sync="dismissCountDown"
                color="primary"
                fade
              >
                ({{dismissCountDown}}) {{ message }}
              </CAlert>
            </div>
          </CCardBody>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect'
var methods = {}

methods.goBack = function () {
  this.$router.go(-1)
}

methods.decorationChanged = function (args) {
  console.log('dec changed')
  console.log(args)
}

methods.labelFun = function (e) {
  console.log('label')
  console.log(e)
}

methods.addRoyalty = function () {
  console.log(this.form.royalties)
  if (this.form.royalties) {
    this.form.royalties.push(this.royalty)
  } else {
    this.form.royalties = [this.royalty]
  }
  this.royalty = this.getRoyalties()
  this.form.royalty_edited = true
}

methods.getPrograms = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    // self.programOptions = response.data
    
    self.programOptions = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.remove = function (image, index) {
  this.removeLoading = true
  const postData = {
    image: image,
    program_id: this.form.program_id,
    index: index
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/media/removeImageFromProgram?token=' + localStorage.getItem('api_token'), postData).then(response => {
    // this.fileLoading = false
    this.form.image_options.splice(index, 1)
    this.removeLoading = false
    console.log(response)
  })
}

methods.uploadFiles = function () {
  // process.env.VUE_APP_SERVER_HOST + '/api/media/uploadFileToOrderGroup?token=' + localStorage.getItem("api_token")
  this.fileLoading = true
  const postData = {
    files: this.imageUploads,
    program_id: this.form.program_id
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/media/uploadFileToProgram?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.fileLoading = false
    // if (!this.form.image_options) {
    //   this.form.image_options = []
    // }
    // this.form.image_options.push(response.data)
    this.form.image_options = response.data
    this.$refs.programDropzone.removeAllFiles()
    console.log(response)
  })
}

methods.copyProgram = function () {
  var that = this
  Swal.fire({
    title: 'Are you sure?',
    text: 'If you submit, this will remove all technique/location combinations for current program.',
    showCancelButton: true,
    confirmButtonText: 'Yes, Copy!',
  }).then((result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      that.copyLoading = true
      // Swal.fire('Saved!', '', 'success')
      const postData = {
        copy_program: that.copy_program,
        program: this.form
      }
      console.log(postData)
      axios.post( that.$apiAdress + '/api/programs/copyTechniqueLocations?token=' + localStorage.getItem("api_token"), postData).then(response => {
        console.log(response)
        that.getTechniques()
        that.copy_program = ''
        that.copyLoading = false
      }).catch(e => {
        console.log(e)
      })
    } else if (result.isDenied) {
      // Swal.fire('Changes are not saved', '', 'info')
      // next()
    }
  })
}

// methods.addTierGroup = function () {
//   if (!this.form.tier_names) {
//     this.form.tier_names = []
//   }
//   var obj = {
//     id: '',
//     program_id: this.form.program_id,
//     tier_name: '',
//     styles: '',
//     tiers: [
//       {
//         id: '',
//         program_id: this.form.program_id,
//         min_quantity: '',
//         num_styles: '',
//         min_color_quantity: '',
//         price: '',
//       }
//     ]
//   }
//   this.form.tier_names.push(obj)
// }

// methods.addTier = function (i) {
//   var obj = {
//     id: '',
//     program_id: this.form.program_id,
//     min_quantity: '',
//     num_styles: '',
//     min_color_quantity: '',
//     price: '',
//   }
//   if (this.form.tier_names[i].tiers) {
//     this.form.tier_names[i].tiers.push(obj)
//   } else {
//     this.form.tier_names[i].tiers = [obj]
//   }
// }

// methods.removeTier = function (val, index, i) {
//   if (val.id) {
//     axios.post(   this.$apiAdress + '/api/programs/removeTier' + '?token=' + localStorage.getItem("api_token"), val).then(response => {
//       this.form.tier_names[i].tiers.splice(index, 1)
//     })
//   }
// }

// methods.getRoyalties = function () {
//   let self = this;
//   this.form = null
//   axios.get(   this.$apiAdress + '/api/royalties/edit?token=' + localStorage.getItem("api_token") + '&program_id=' + self.$route.params.id)
//   .then(function (response) {
//       // self.name = response.data.menulist.name;
//       self.form = response.data.res
//       self.locations = response.data.locations
//       console.log(response)
//   }).catch(function (error) {
//       console.log(error);
//       // self.$router.push({ path: '/login' });
//   });
// }

methods.getTechniques = function () {
  let self = this;
  this.form = null
  axios.get(   this.$apiAdress + '/api/programs/edit?token=' + localStorage.getItem("api_token") + '&program_id=' + self.$route.params.id)
  .then(function (response) {
      // self.name = response.data.menulist.name;
      self.form = response.data.res
      self.form.royalty_edited = false
      self.locations = response.data.locations
      console.log(response)
  }).catch(function (error) {
      console.log(error);
      // self.$router.push({ path: '/login' });
  });
}

methods.update = function () {
  let self = this;
  this.loading = true
  console.log(this.form)
  axios.post(   this.$apiAdress + '/api/programs/save' + '?token=' + localStorage.getItem("api_token"), self.form)
  .then(function (response) {
      self.message = 'Successfully updated this style.';
      self.loading = false
      self.showAlert();
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getRoyalties = function () {
  return {
    id: '',
    program_id: '',
    charge_name: '',
    charge_code: '',
    price: '',
    per_piece: ''
  }
}

methods.addFile = function (file) {
  console.log('file added')
  console.log(file)
  this.imageUploads.push(file)
}

methods.showAlert = function () {
  this.dismissCountDown = this.dismissSecs
}

methods.getRoles = function () {
  axios.get(this.$apiAdress + '/api/roles?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    // this.roles = response.data
    var that = this
    this.roles = []
    response.data.forEach(function (val) {
      that.roles.push(val.name)
    })
  })
}

methods.checkActive = function () {
  this.activeProgDec = this.$refs.programDecorations.active
}

export default {
  name: 'EditProgram',
  data: () => {
    return {
        form: {
          name: '',
          internal_id: '',
          custom_form_internal_id: '',
          days_out: 0,
          order_until_date: '',
          allow_blanks: 0,
          subtract_quantity: 0,
          subtract_upcharge: 0,
          free_decorations: 1,
          min_locations: 1,
          techniques: null,
          meet_min_quantity_deduction: '',
          one_style_per: 0,
          split_by_product_class: 0,
          allow_one_to_23_upcharge: 1,
          color_type_options: '',
          copy_styles_to_programs: '',
          sixes: '',
          layout_text_option: '',
          rush_optionn: '',
          ribbon_option: '',
          hangtags_option: '',
          string_tags_option: '',
          in_hands_date_option: '',
          program_emails: '',
          imperial_belts_settings: 0,
          pm_belts_settings: 0,
          other_color_option: 0,
          show_production_notes: 0,
          blank_deduction_price: '',
          royalties: [],
          royalty_edited: false,
          additional_locations_charge: '',
          addtiional_locations_charge_cost: '',
          insert_net_suite_combined_sizes: 0
        },
        royalty: {
          id: '',
          program_id: '',
          charge_name: '',
          charge_code: '',
          price: '',
          per_piece: ''
        },
        activeProgDec: 0,
        loading: false,
        colorTypeOptions: ['Club Colors', 'Color Coordinate', 'Match Artpack', 'See Dec Instructions', 'Special Instructions', 'True Color', 'True Color Distressed', 'Washed', 'Washed Distressed', 'Tonal'],
        imageUploads: [],
        dropzoneOptions: {
            url: 'test',
            autoProcessQueue: false,
            thumbnailWidth: 150,
            maxFilesize: 10.0,
            headers: { "Upload File(s)": "" }
        },
        programOptions: null,
        decorationCollapsed: false,
        copy_program: '',
        roles: null,
        locations: null,
        message: '',
        dismissSecs: 3,
        dismissCountDown: 0,
        copyLoading: false,
        fileLoading: false,
        colors: null,
        decorations: null,
        removeLoading: false,
        techniqueCollapsed: false,
        royaltiesCollapsed: false,
        styles: null,
        programs: null,
        techTypes: ['TAPE', 'H', 'PPE', 'PPMP', 'PPSM', 'PPHI', 'PPL']
    }
  },
  components: {
    Multiselect
  },
  methods: methods,
  watch: {
    // '$refs.programDecorations.active': function (newVal, oldVal) {
    //   console.log('active changed');
    //   console.log(newVal)
    // }
  },
  computed: {
    'activeProgramDecoration' () {
      var i = ''
      // if (this.$refs.programDecorations) {
         i = this.$refs.programDecorations.active
      // }
      console.log('activeprogram')
      console.log(i)
      return i
    }
  },
  mounted: function(){
    // this.getRoyalties()
    this.getTechniques()
    this.getRoles()
    var that = this
    this.getPrograms()
    setTimeout(function () {
      console.log(that.$refs)
      $('.carousel-control-next').on('click', function () {
        // console.log('button clicked!')
        that.checkActive()
      })
      $('.carousel-control-prev').on('click', function () {
        // console.log('button clicked!')
        that.checkActive()
      })
    }, 2000)
  }
}


</script>
